import { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useAppContext } from 'src/contexts/AppContext';
import { CoBrandId } from 'src/WebApiController';

export const HelmetContent = ({ routeTitle }: { routeTitle?: string }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // We have to use this because the dark mode settings in POS is not the same as the browser's dark mode
  useEffect(() => {
    const matcher = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkMode(matcher.matches);

    // Listen for theme changes dynamically
    const listener = (e: MediaQueryListEvent) => setIsDarkMode(e.matches);
    matcher.addEventListener('change', listener);

    // Cleanup
    return () => matcher.removeEventListener('change', listener);
  }, []);

  const { cobrandId } = useAppContext();

  const routeTitleDefault = useMemo(() => {
    switch (cobrandId) {
      case CoBrandId.TicketUtil:
        return 'TicketUtils';
      case CoBrandId.Starburst:
        return 'Starburst Pro';
      case CoBrandId.ReachPro:
        return 'ReachPro';
      case CoBrandId.StubHub:
      default:
        return 'StubHub Pro';
    }
  }, [cobrandId]);

  const title = routeTitle
    ? `${routeTitleDefault} - ${routeTitle}`
    : routeTitleDefault;

  return cobrandId === CoBrandId.ReachPro ? (
    <Helmet>
      <link
        rel="shortcut icon"
        href={isDarkMode ? '/reach/Dark.ico' : '/reach/Light.ico'}
        type="image/x-icon"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={isDarkMode ? '/reach/Dark_16.png' : '/reach/Light_16.png'}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={isDarkMode ? '/reach/Dark_32.png' : '/reach/Light_32.png'}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="96x96"
        href={isDarkMode ? '/reach/Dark_96.png' : '/reach/Light_96.png'}
      />
      <title>{title}</title>
    </Helmet>
  ) : (
    <Helmet>
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="96x96"
        href="/favicon-96x96.png"
      />
      <title>{title}</title>
    </Helmet>
  );
};
